import React from "react";
import { Button, Stack } from "react-bootstrap";
import { faBan, faUnlock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IIdentity } from "../../../customTypings/user/Identity";

interface UserActionButtonsProps {
    user: IIdentity;
    currentUserId?: string;
    updating: boolean;
    onDisable: (id: string) => void;
    onEnable: (id: string) => void;
    onUnlock: (id: string) => void;
    onUpdateTwoFA: (id: string, isRequired: boolean) => void;
    onResetTwoFA: (id: string) => void;
}

export const UserActionButtons: React.FC<UserActionButtonsProps> = ({
    user,
    currentUserId,
    updating,
    onDisable,
    onEnable,
    onUnlock,
    onUpdateTwoFA,
    onResetTwoFA
}) => {
    return (
        <Stack gap={2} direction="horizontal" className="mb-3">
            {user.isEnabled ? (
                <Button
                    variant="danger"
                    onClick={() => onDisable(user.id)}
                    disabled={updating || user.id === currentUserId}
                >
                    <FontAwesomeIcon icon={faBan} className="me-1" /> Disable User
                </Button>
            ) : (
                <Button
                    className="me-2"
                    variant="success"
                    onClick={() => onEnable(user.id)}
                    disabled={updating}
                >
                    Enable User
                </Button>
            )}
            
            {user.isLocked && (
                <Button
                    variant="success"
                    onClick={() => onUnlock(user.id)}
                    disabled={updating}
                >
                    <FontAwesomeIcon icon={faUnlock} className="me-1" /> Unlock
                </Button>
            )}
            
            {!user.twoFAIsEnabled ? (
                <Button
                    variant="success"
                    onClick={() => onUpdateTwoFA(user.id, true)}
                    disabled={updating}
                >
                    Enable two-step sign-in
                </Button>
            ) : (
                <Button
                    variant="danger"
                    onClick={() => onUpdateTwoFA(user.id, false)}
                    disabled={updating}
                >
                    Disable two-step sign-in
                </Button>
            )}
            
            <Button
                variant="danger"
                onClick={() => onResetTwoFA(user.id)}
                disabled={updating}
            >
                Reset two-step sign-in
            </Button>
        </Stack>
    );
};
